import React from "react"
import ss from "../styles/components/Preloader.module.scss"

export function Preloader() {
  return (
    <div className={ss.lds_ellipsis}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
